import { c as _c } from "react/compiler-runtime";
import { Flex, FlexColumn, TextBody } from "@opensea/ui-kit";
import { useMountEffect } from "@opensea/ui-kit/hooks";
import { Error } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { useTrackEvent } from "../../providers/TrackEventProvider";
import { FlowState } from "../../stores/flowStore";
import { Button } from "../Button";
export const PriceChangeWarning = t0 => {
  const $ = _c(14);
  const {
    priceValidation,
    onContinue
  } = t0;
  const t = useTranslations("wallet.PriceChangeWarning");
  const trackEvent = useTrackEvent();
  let t1;
  if ($[0] !== priceValidation || $[1] !== trackEvent) {
    t1 = () => {
      trackEvent("Inline Price Changed Warning Shown", {
        priceValidation,
        flow: FlowState.flow?.type
      });
    };
    $[0] = priceValidation;
    $[1] = trackEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useMountEffect(t1);
  if (!priceValidation.hasPriceChanged) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Error className="flex-shrink-0 text-warning" size={24} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("description");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <Flex className="items-center gap-2">{t2}<TextBody color="text-secondary" size="sm">{t3}</TextBody></Flex>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onContinue || $[9] !== t) {
    t5 = onContinue && <Button onClick={onContinue} variant="destructive">{t("continue")}</Button>;
    $[8] = onContinue;
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <FlexColumn className="w-full justify-between gap-4 lg:flex-row">{t4}{t5}</FlexColumn>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};